/**
 * KBv2 Tabs
 */
export const INSIGHTS_TAB = 'insights';
export const ARTICLES_TAB = 'articles';
/**
 * KBv3 Tabs
 */
export const Tabs = {
  manage: 'manage',
  analyze: 'analyze',
  kbAgent: 'kbAgent'
};